<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial de gastos
            <router-link
              :to="{ name: 'NuevoGasto', params: {
                  config: { page: page, dates: selectedDate }
                } }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Gasto
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6" lg="6" xl="4">
                <DateSelector
                  class="z-custom-2 mb-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
            </CRow>

            <CDataTable
              hover
              bordered
              responsive
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :items-per-page="Number(limit)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow class="">
                  <CCol v-if="advanceFilter" sm="11" col="10">
                    <CRow class="advance-filter mb-4">
                      <CCol md="6" class="py-1">
                        <label class="d-block">Provedor:</label>
                        <div class="d-flex margin-multi align-items-center">
                          <multiselect
                            v-model="query.proveedores"
                            :options="proveedores"
                            :multiple="true"
                            :loading="isLoadingInfo"
                            label="label"
                            track-by="label"
                            placeholder="Proveedores"
                            :close-on-select="false"
                            :clear-on-select="false"

                          >
                            <template #no-options>Sin resultados.</template>
                          </multiselect>
                          <transition name="fade">
                            <div v-show="query.proveedores && query.proveedores.length" @click="()=>{query.proveedores = []}">
                              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                            </div>
                          </transition>
                        </div>
                      </CCol>
                      <CCol md="6" class="py-1" v-if="false && showUbicaciones">
                        <label class="d-block">Ubicaciones:</label>
                        <div class="d-flex margin-multi align-items-center">
                          <multiselect
                            v-model="query.ubicaciones"
                            :options="ubicaciones.map(ubicacion => ({ value: ubicacion.id, label: ubicacion.payload.nombre })).sort((a,b)=>a.label.localeCompare(b.label))"
                            :multiple="true"
                            :loading="isLoadingPage"
                            label="label"
                            track-by="label"
                            placeholder="Ubicaciones"
                            :close-on-select="false"
                            :clear-on-select="false"

                          >
                            <template #no-options>Sin resultados.</template>
                          </multiselect>
                          <transition name="fade">
                            <div v-show="query.ubicaciones && query.ubicaciones.length" @click="()=>{query.ubicaciones = []}">
                              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                            </div>
                          </transition>
                        </div>
                      </CCol>


                      <CCol sm="6" class="py-1">
                        <label>Gastos:</label>
                        <v-select
                          :options="servicios"
                          :loading="isLoadingInfo"
                          class="margin-multi"
                          placeholder="Selecciona un servicio"
                          v-model="query.servicio"
                        >
                          <template #open-indicator="{ attributes }">
                            <CIcon
                              v-bind="attributes"
                              class="cursor-p"
                              name="cil-caret-bottom"
                            />
                          </template>
                          <template #no-options>
                            Sin resultados.
                          </template>
                        </v-select>
                      </CCol>

                      <CCol md="6" class="py-1">
                        <label class="d-block">Costo Total:</label>
                        <CRow>
                          <CCol><CInput type="number" :value.sync="$v.query.costo.start.$model" placeholder="De" class="mb-0 align-self-center" :isValid="query_costo_start" /></CCol>
                          <CCol><CInput type="number" :value.sync="$v.query.costo.end.$model" placeholder="Al" class="mb-0 align-self-center"  :isValid="query_costo_end" /></CCol>
                        </CRow>
                      </CCol>

                      <CCol md="6" class="py-1">
                        <label class="d-block">Comentarios:</label>
                        <CInput v-model="query.comentarios" placeholder="Comentarios" class="mb-0 align-self-center" />
                      </CCol>
                      <CCol col="10" class="pt-3">
                        <CButton @click="validForm" color="primary"> Buscar</CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol v-else sm="11" col="10">
                    <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Busqueda avanzada:</label>
                            <CSwitch :checked="advanceFilter" @update:checked="toggleAdvanceFilter()" class="mx-1" color="primary" variant="3d" />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Hora:</label>
                            <CSwitch
                              @update:checked="toggleHora()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Fecha de creación:</label>
                            <CSwitch
                              @update:checked="toggleCreatedAt()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Ubicaciones:</label>
                            <CSwitch
                              @update:checked="toggleUbicaciones()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>

                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                  <div v-if="laboresIsSelected" class="ml-2 d-flex flex-column justify-content-end align-items-end w-100">
                    <div class="d-flex justify-content-end align-items-center">
                      <CButton
                        @click="show = true"
                        color="danger"
                        class="mr-1 sp-width-butom  d-flex align-items-center"
                      >
                        <CIcon class="mr-1" name="cil-list" />Cancelar Gastos
                      </CButton>
                    </div>
                    <label class="d-block text-right mt-2 mb-0">{{_countSelected_}} elementos selecciónados</label>
                  </div>
                </CRow>
              </template>

              <template #check-header>
                <div class="d-flex flex-row" v-if="items.length">
                  <input id="all" type="checkbox" @input="checkAll" :checked="_laboresCheck_" class="ml-3" />
                </div>
              </template>
              <template #check="{item}">
                <td class="py-2"><input v-model="laboresCheck[item.folio]" type="checkbox" class="form-check-input ml-3" /></td>
              </template>

              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_gastos.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_gastos.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #servicio_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Gastos</span>
                  <OrderButtons :onClick="sortField" :field="'servicio.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #proveedor_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Proveedor</span>
                  <OrderButtons :onClick="sortField" :field="'proveedor.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #servicio_id="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.servicio.payload.nombre }}</td>
                <!-- <td class="py-2">{{ getServicio(item.payload.encabezado.servicio_id) }}</td> -->
              </template>
              <template #proveedor_id="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.proveedor?item.payload.encabezado._relaciones.proveedor.payload.nombre:'' }}</td>
                <!-- <td class="py-2">{{ getServicio(item.payload.encabezado.servicio_id) }}</td> -->
              </template>
              <template #empresa_id="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.empresa?item.payload.encabezado._relaciones.empresa.payload.nombre:'' }}</td>
                <!-- <td class="py-2">{{ getServicio(item.payload.encabezado.servicio_id) }}</td> -->
              </template>
              <template #folio_factura="{item}">
                <td class="py-2">{{ item.payload.encabezado.folio_factura?item.payload.encabezado.folio_factura:'' }}</td>
                <!-- <td class="py-2">{{ getServicio(item.payload.encabezado.servicio_id) }}</td> -->
              </template>
              <template #costo="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.payload.encabezado.costo,1)}}
                </td>
              </template>
               <template #ubicaciones="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion.map(m=>m.payload.nombre).join()  }}</td>
              </template>

              <template #hour-header>
                <div class="d-flex flex-row">
                  <span v-show="showHora">Hora</span>
                </div>
              </template>
              <template #hour="{item}">
                <td class="py-2">
                  <span v-show="showHora">{{ getHour(item.payload.encabezado.fechahora) }}</span>
                </td>
              </template>
              <template #created_at-header>
                <div class="d-flex flex-row">
                  <span v-show="showCratedAt">Fecha de creación</span>
                </div>
              </template>
              <template #created_at="{item}">
                <td class="py-2">
                  <span v-show="showCratedAt">{{ getFullDate(item.created_at) }}</span>
                </td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditGasto',
                      params: {
                        folio: item.folio,
                        config: { page: page, dates: selectedDate }
                      }
                    }"
                  >
                    <CButton color="primary" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>

              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #facturado="{item, index}">
                <td class="py-2">
                  <div class="d-flex no-gap">
                    <CButton v-if="item.payload.encabezado.facturado === undefined" color="info" square size="sm" class="btn-left" @click="()=>toggleFacturar(index, item, true)">Si</CButton>
                    <CButton v-if="item.payload.encabezado.facturado === undefined" color="danger" square size="sm" class="btn-right" @click="()=>toggleFacturar(index, item, false)">No</CButton>
                  </div>
                  <span v-if="item.payload.encabezado.facturado === false" @dblclick="item.payload.encabezado.facturado = undefined" class="text-danger">No facturado</span>
                  <span v-if="item.payload.encabezado.facturado === true" @dblclick="item.payload.encabezado.facturado = undefined" class="text-success">Facturado</span>
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerGasto',
                      params: { id: item.folio, config: { page: page, dates: selectedDate }}
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                  <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                  <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                  >Cancelar</CButton>
                </td>
              </template>
              <template #under-table>
                <div class="footer-table">
                  <div style="gap: 5px" class="d-flex align-items-center justify-content-start">
                    Total {{total}} ,
                    <CSelect
                    :value="limit"
                    label=""
                    invalidFeedback="Campo requerido, debe seleccionar una opción"
                    :options="[10,25,50,100]"
                    @update:value="v=>limit=v"
                    class="mb-0"
                    />{{" "}}artículos / página
                  </div>
                  <CPagination :activePage.sync="page" :pages="pages" align="center"
                    @update:activePage="e => actualizarInfo()" />
                </div>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="show"
    >
      <template #header>
        <h5 class="modal-title">Cancelar gastos</h5>
        <CButtonClose @click="show = false" class="text-white" />
      </template>
    ¿Esta seguro que quiere cancelarlos?
    <template #footer>
        <CButton @click="show = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelarDocs()" color="success">Aceptar</CButton>
    </template>
    </CModal>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar Gasto"
      color="danger"
    >
      <h5 class="text-center">¿Deseas cancelar el gasto con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Cancelar Gasto</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelDocto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
     <CModal
     :closeOnBackdrop="false"
      size="sm"
      :title="loadingModal||''"
      :centered="true"
      color="info"
      :show.sync="_loadingModal"
    >
      <template #footer>
        <strong></strong>
      </template>
      <div
        class="w-100 d-flex justify-content-center"
      >
        <div class="sk-flow align-items-center">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </CModal>

    <CModal
      :show.sync="facturarModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Facturar gasto"
      color="info"
    >
      <h5 v-if="facturarModalStatus" class="text-center">¿Deseas facturar la orden de compra con folio {{ this.itemModal.name }}?</h5>
      <h5 v-else class="text-center">¿Deseas desfacturar la orden de compra con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 v-if="facturarModalStatus" class="modal-title">Facturar Orden de Compra</h5>
        <h5 v-else class="modal-title">Desfacturar Orden de Compra</h5>
        <CButtonClose @click="facturarModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="facturarModal = false" color="danger">Cancelar</CButton>
        <CButton @click="facturar(itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>

  </div>
</template>

<script>
// import { setupCalendar, DatePicker } from "v-calendar";
import DateSelector from "../../customComponents/DateSelector";
import moment from "moment";
import OrderButtons from "../../customComponents/OrderButtons";
import GridAutorMixin from "../../mixins/GridAutor";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { validationMixin } from "vuelidate";
import "vue-select/dist/vue-select.css";

// setupCalendar({
//   firstDayOfWeek: 2 // Monday
// });

const fields = [
    { key: "check", label: "", _style: "width: 40px" },
    { key: "folio", label: "Folio", _style: "max-width: 70px; width: 1%" },
    { key: "fechahora", label: "Fecha", _style: "max-width: 70px; width: 1%" },
    { key: "empresa_id", label: "Empresa", _style: "" },
    { key: "hour", label: "Hora", _style: "", },
    { key: "estado", label: "Estado", _style: "" },
    { key: "servicio_id", label: "Gasto", _style: "" },
    { key: "folio_factura", label: "Folio Factura", _style: "" },
    { key: "proveedor_id", label: "Proveedor", _style: "" },
    // { key: "costo_unitario", label: "Costo Unitario", _style: "width:10%" },
    // { key: "cantidad", label: "Cantidad", _style: "width:10%" },
    { key: "costo", label: "Costo Total", _style: "max-width: 170px;" },
    { key: "ubicaciones", label: "Ubicaciones", _style: "", },
    { key: "created_at", label: "Fecha de creación", _style: "" },
    {
      key: "autor",
      label: "",
      _style: "",
    },
    {
      key: "facturado",
      label: "Facturado",
      _style: "width:1%",
      sorter: false,
      filter: false
    },
    {
      key: "ver",
      label: "",
      _style: "width: 40px",
      sorter: false,
      filter: false
    },
    // {
    //   key: "edit",
    //   label: "",
    //   _style: "width: 50px",
    //   sorter: false,
    //   filter: false
    // },
    {
      key: "reporte",
      label: "",
      _style: "width: 40px",
      sorter: false,
      filter: false
    },
    {
      key: "cancel",
      label: "",
      _style: "width: 70px",
      sorter: false,
      filter: false
    }
  ]




export default {
  name: "Gasto",
  components: {
    DateSelector,
    OrderButtons,
    Multiselect,
    vSelect,
  },
  mixins: [GridAutorMixin,validationMixin],
  validations: {
    query:{
      costo:{
        start:{
          maxValue: (v,costo)=>{
            return costo.start && costo.end ? Number(v) <= Number(costo.end) : true
          }
        },
        end:{
          minValue: (v,costo)=>{
            return costo.start && costo.end ? Number(v) >= Number(costo.start) : true
          }
        }
      }
    }
  },
  data() {
    return {

      limit: 10,
      total: 0,
      laboresCheck: {},
      loadingModal: '',
      show: false,
      query:{
        costo:{start:'',end:''},
        semanas:{start:'',end:''},
      },
      showHora: false,
      showCratedAt: false,
      advanceFilter: false,

      proveedores: [],
      items: [],
      warningModal: false,
      error: "",
      config: this.$route.params.config,
      isCreated: false,
      gastos: [],
      isLoteActive: true,
      dropdownCustom: false,
      showCancel: false,
      showUbicaciones: false,
      color1: "primary",
      color2: "secondary",
      servicios: [],
      filter: "",
      ubicaciones: [],
      // ubicacionesAll: [],
      // cultivos: [],
      // cultivosAll: [],
      // lotes: [],
      // cultivo: null,
      // ubicacion: null,
      // lote: null,
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      isLoadingInfo: false,
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      actualSort: "doc_gastos.payload->encabezado->fechahora",
      actualSortJoin: "",
      sort: [
        {
          field: "doc_gastos.folio",
          isSorter: true
        },
        {
          field: "doc_gastos.payload->encabezado->fechahora",
          isSorter: true
        }
      ],
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      loader:{},

      facturarModal: false,
      facturarModalStatus: true,
    };
  },

  created() {
    if (this.ubicacionRaiz == "") {
      this.items = []
      return
    }
    this.isCreated = false;
    this.page = this.config ? this.config.page : 1;

    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    this.actualizarInfo(true);
  },

  computed: {
    query_filter(){
      return Object.keys(this.query).reduce((v,key)=>{
        if(key==='proveedores'){
          const proveedoresIds = this.query.proveedores.map(m=>m.value)
          proveedoresIds.length&&
            v.push({
              field: "doc_gastos.payload->encabezado->proveedor_id",
              operator: "regexp",
              value: `[[:<:]](${proveedoresIds.join('|')})[[:>:]]`
            })
        }

        if(key==='ubicaciones'){
          const ubicacionesIds = this.query.ubicaciones.map(m=>m.value)
          this.showUbicaciones&&ubicacionesIds.length&&
            v.push({
              field: "doc_gastos.payload->encabezado->ubicaciones",
              operator: "regexp",
              value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
            })
        }
        if(key==='servicio'){
          this.query.servicio&&
          v.push({
            field: "doc_gastos.payload->encabezado->servicio_id",
            operator: "=",
            value: `${this.query.servicio.value}`
          })
        }
        if(key==='comentarios'){
          this.query.comentarios&&
          v.push({
            field: "doc_gastos.payload->encabezado->comentarios",
            operator: "like",
            value: `%${this.query.comentarios}%`,
            collate: "utf8mb4_unicode_ci"
          })
        }

        if(key==='costo'){
          this.query.costo.start&&
          v.push({
            field: "doc_gastos.payload->encabezado->costo",
            operator: ">=",
            value: Number(this.query.costo.start),
          })
          this.query.costo.end&&
          v.push({
            field: "doc_gastos.payload->encabezado->costo",
            operator: "<=",
            value: Number(this.query.costo.end),
          })
        }
        return v
      },[])
    },
    query_costo_start(){
      return this.$v.query.costo.start.$dirty?!this.$v.query.costo.start.$invalid:null
    },
    query_costo_end(){
      return this.$v.query.costo.end.$dirty?!this.$v.query.costo.end.$invalid:null
    },
    _loadingModal:{
      get(){
        return !!this.loadingModal
      },
      set(val){
        this.loadingModal = val||''
      }
    },
    _countSelected_(){
      return Object.keys(this.laboresCheck).reduce((v,key)=>this.laboresCheck[key]?v+1:v,0)
    },
    _laboresCheck_(){
      return Object.keys(this.laboresCheck).length&&this.items.map(m=>m.folio).every(key=>this.laboresCheck[key])
    },
    docsLaboresCancel_(){
      return this.laboresCheck_.map(m=>({
        folio: m,
        serie: "",
        schema: "gastos"
      }))
    },
    laboresIsSelected(){
      return Object.keys(this.laboresCheck).some(s=>this.laboresCheck[s])
    },
    laboresCheck_(){
      return Object.keys(this.laboresCheck).filter(ff=>this.laboresCheck[ff])
    },
    fields(){
      return fields.filter(ff=>{
        if(
          (ff.key==='ubicaciones'&&!this.showUbicaciones) ||
          (ff.key==='hour'&&!this.showHora) ||
          (ff.key==='created_at'&&!this.showCratedAt) ||
          (ff.key==='autor'&&!this.mostrarColumnaAutor)
        ){
          return false
        }
        return true
      })
    },
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    filteredItems() {
      return this.items.filter(
        i =>
          i.folio
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getDate(i.payload.encabezado.fechahora)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getServicio(i.payload.encabezado.servicio_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    limit() {
      this.actualizarInfo()
    },
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
      Object.keys(this.laboresCheck).forEach(key=>{
        if (!newV.find(f=>f.folio === Number(key))) {
          delete this.laboresCheck[key];
        }
      })
    },
    ubicacionRaiz: function() {
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }
      this.page = 1;
      this.actualizarInfo(true);
    }
  },

  methods: {

    facturar(folio){
      this.$store.dispatch("customDocumentoActualizarHTTP", {
                schema: "gastos",
                folio,
                payload: {
                    encabezado: {
                        facturado: this.facturarModalStatus
                    }
                }
            }).then(() => {
                this.alertSuccess = true
            }).catch(error => {
                this.error = error.message;
                this.warningModal = true;
                this.isLoading = false;
            }).finally(() => {
                this.facturarModal = false;
                this.isLoading = false;
                this.actualizarInfo();
            });
    },

    getHour(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date);
      return newDate.format("HH:mm:ss");
    },
    validForm(){
      this.$v.$reset();
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.actualizarInfo()
      }
    },
    cancelarDocs(){
      this.show = false
      this.isLoading = true
      this.isLoading = false

      this.loadingModal =  "Cancelando..."
      this.$store.dispatch("customDocumentoCancelHTTP",this.docsLaboresCancel_)
          .then(()=>{
            this.actualizarInfo()
          })
          .catch(rej => {
            console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.editModal = false
            this.edit = {}
            this.isLoading = false
            this.loadingModal = ''
            this.laboresCheck = {}
          })
    },
    checkAll(e){
        this.laboresCheck = this.items.reduce((v,c)=>{
          v[c.folio] = e.target.checked
          return v
        },{})

    },
    toggleAdvanceFilter() {
      this.advanceFilter = !this.advanceFilter;
    },
    toggleHora() {
      this.showHora = !this.showHora;
    },
    toggleCreatedAt() {
      this.showCratedAt = !this.showCratedAt;
    },
    getReporte(index,item){
      if(this.loader[index]){
        return
      }
      this.loader[index] = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_gastos",
        params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);


        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de gastos.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false
          this.$forceUpdate();
        });
    },
    searchTimeOut() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleUbicaciones() {
      this.showUbicaciones = !this.showUbicaciones;
    },
    toggleShowCancel() {
      // console.log("entro");
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    getServicio(servicio_id) {
      const servicioActual = this.servicios.filter(
        servicio => servicio.id == servicio_id
      );
      if (servicioActual.length > 0) {
        return servicioActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    getDate(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date,"YYYY-MM-DD 00:00:00");
      return newDate.format("DD/MM/YYYY");
    },
    getFullDate(date) {
      if(date === undefined || date === '') {
        return 'N/A';
      }
      let newDate = moment(date);
      return newDate.format("DD/MM/YYYY HH:mm:ss");
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    getSorted(field) {
      const newSort = this.sort.find(item => item.field == field);
      if (newSort) {
        return newSort.isSorter;
      }
      return false;
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleFacturar(index, item, status) {
      this.facturarModal = true;
      this.facturarModalStatus = status;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleResetFacturar(index, item) {

    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive
        ? ((this.cultivo = null), (this.ubicacion = null))
        : (this.lote = null);
      this.filterLotes();
    },
    dateSelection() {
      if(this.advanceFilter){
        return
      }
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    filterLotes() {
      // let compareLote = this.lotes.find(lote => lote.value == this.lote);
      return this.items.filter(
        doc =>
          new Date(doc.payload.encabezado.fechahora) >=
            this.selectedDate.start &&
          new Date(doc.payload.encabezado.fechahora) <= this.selectedDate.end
      );
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "gastos",
          folio: id
        })
        .then(res => {
          console.log(res.data);
          this.actualizarInfo();
          // const index = this.items.findIndex(item => item.folio == id);
          // this.items[index].estado = "cancelado";
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          this.cancelModal = false;
        });
    },
    actualizarInfo(flagCombos = false){
      this.$v.$reset();
      this.isLoading = true;

      let template = {
        schema: "gastos",
        limit: this.limit,
        page: this.page,
        filter: {
          wherein: [
            {
              field: "doc_gastos.payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "doc_gastos.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format(
                "YYYY-MM-DD 00:00:00"
              )
            },
            {
              field: "doc_gastos.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null

      !this.advanceFilter && this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            orWhere: [
              {
                field: "doc_gastos.folio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_gastos.payload->encabezado->costo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ...this.mostrarColumnaAutor?[
              {
                field: "doc_gastos.author->correo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
            ],
            orWhereJoin: [
              {
                field: "servicio.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "proveedor.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
            ]
          }
        }
      }) : null;

      if(this.advanceFilter&&(this.query_filter.length>0)){
        template.filter.and = {
          ...this.query_filter.length?{where: this.query_filter}:{}
        }
      }

      !this.showCancel
        ? (template = {
            ...template,
            filter: {
              ...template.filter,
              where: [
                ...template.filter.where,
                {
                  field: "doc_gastos.estado",
                  operator: "!=",
                  value: "cancelado"
                }
              ]
            }
          })
        : null;

      const documento = [
        this.$store.dispatch("customDocumentoHTTP", template),
      ]
      if(flagCombos){
        this.isLoadingInfo = true
        documento.push(
          this.$store.dispatch("customHTTP", {
            schema: "ubicaciones",
            filter: {
              where: [
                {
                  field: "payload->suspendido",
                  value: false,
                  operator: "="
                }
              ]
            },
            order:[{
              field: 'payload->nombre',
              direction: 'asc'
            }]
          }),
          this.$store.dispatch("customHTTP", {
            schema: "proveedores",
          }),
          this.$store.dispatch("customHTTP", {
          schema: "servicios",
          filter: {
            where: [
              {
                field: "payload->pertenece_id",
                value: 0,
                operator: "!="
              }
            ]
          }
        }),
        );
      }
      Promise.all(documento)
        .then(([documentos,ubicaciones,proveedores,servicios]) => {
          this.items = documentos.data;
          this.pages = documentos?.paginate?.last_page;
          this.page = documentos?.paginate?.current_page;
          this.total = documentos?.paginate?.total||0

          if(ubicaciones&&ubicaciones.data.length>0){
            this.ubicaciones = ubicaciones.data
          }

          if(proveedores&&proveedores.data.length>0){
            this.proveedores = proveedores.data.map(proveedor => {
              return {
                value: proveedor.id,
                label: proveedor.payload.nombre
              };
            }).sort((a,b)=>a.label.localeCompare(b.label));
          }

          if(servicios&&servicios.data.length>0){
            const pertenece_ids = servicios.data.map(m=>m.payload.pertenece_id);
            this.servicios = servicios.data.map(servicio => {
              return { value: servicio.id, label: servicio.payload.nombre, pertenece_id:servicio.payload.pertenece_id };
            }).filter(ff=>!pertenece_ids.includes(ff.value));
          }

          this.isCreated = true;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => {
          this.isLoading = false
          this.isLoadingInfo = false
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.footer-table{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
  .dropdown-menu{
    min-width: 14rem;
  }
  .advance-filter .multiselect__spinner{
    height: 30px;
  }
  .advance-filter .multiselect__placeholder{
    margin-bottom: 0px;
  }
  .advance-filter .multiselect__select{
    height: 34px;
  }
  .advance-filter .multiselect__tags{
      max-height: 35px;
      overflow: auto;
      min-height: unset;
      padding: 5px 40px 5px 5px;
  }
  .advance-filter .multiselect__content-wrapper{
      width: 100%;
  }
  .advance-filter .vs__dropdown-toggle{
      height: 35px;
  }
  </style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.padding-left-custom {
  padding-right: 5rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
